import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export function exibirVermelhos(
  atendimentos,
  parametro_enfermeiro,
  parametro_medico
) {
  return atendimentos.filter((item) => {
    let ultimo_atendimento_enfermeiro =
      item.atendimentos[item.atendimentos.length - 1].enfermeiro
    let ultimo_atendimento_medico =
      item.atendimentos[item.atendimentos.length - 1].medico
    if (
      Number(
        ultimo_atendimento_enfermeiro - Number(parametro_enfermeiro) < 0
      ) ||
      Number(ultimo_atendimento_medico - Number(parametro_medico) < 0)
    ) {
      return true
    } else {
      return false
    }
  })
}

export function exibirVerdes(
  atendimentos,
  parametro_enfermeiro,
  parametro_medico
) {
  return atendimentos.filter((item) => {
    let ultimo_atendimento_enfermeiro =
      item.atendimentos[item.atendimentos.length - 1].enfermeiro
    let ultimo_atendimento_medico =
      item.atendimentos[item.atendimentos.length - 1].medico
    if (
      Number(
        ultimo_atendimento_enfermeiro - Number(parametro_enfermeiro) < 0
      ) ||
      Number(ultimo_atendimento_medico - Number(parametro_medico) < 0)
    ) {
      return false
    } else {
      return true
    }
  })
}

export function generatePdf(cadastros, parametro_enfermeiro, parametro_medico) {
  let title_pdf = 'Informatiza APS'
  let titlePdfSave = utils.methods.titlePdf('Informatiza APS', '')
  let description_pdf = 'Atendimentos por função no mês atual'
  let headers_pdf = [
    'UNIDADE DE SAÚDE',
    'EQUIPE',
    'INE',
    {
      content: 'ATENDIMENTOS',
      colSpan: 4,
    },
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_unidade_de_saude = cadastros[i].no_unidade_de_saude
    obj.no_equipe = cadastros[i].no_equipe
    obj.nu_ine = cadastros[i].nu_ine
    obj.atendimentos = cadastros[i].atendimentos
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())

  let table = formatTable(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      // Data atual
      verticalPosition += 6
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0')
      let ano = data.getFullYear()
      let dataAtual = dia + '/' + mes + '/' + ano
      doc.setFontSize(12)
      doc.text(`Data: ${dataAtual}`, 15, verticalPosition, null, null)

      verticalPosition += 6

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        columnStyles: {
          3: {
            cellWidth: 100,
          },
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
          minCellHeight: 30,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        didDrawCell: function (data) {
          // console.log(data)
          if (data.column.dataKey === 3 && data.cell.section == 'body') {
            let atendimentos = data.row.raw[3]
            // Tabela enfermeiro
            let headEnfermeiro = atendimentos.map((el) => el.mes_atend)
            let bodyEnfermeiro = atendimentos.map((el) => el.enfermeiro)
            headEnfermeiro.unshift('Função')
            bodyEnfermeiro.unshift('Enfermeiro')
            headEnfermeiro.push('Parâmetro')
            bodyEnfermeiro.push(parametro_enfermeiro)
            headEnfermeiro.push('Diferença')
            bodyEnfermeiro.push(
              Number(atendimentos[atendimentos.length - 1].enfermeiro) -
                Number(parametro_enfermeiro)
            )
            doc.autoTable({
              head: [[...headEnfermeiro]],
              body: [[...bodyEnfermeiro]],
              headStyles: {
                fillColor: '#ccc',
                fontSize: 6,
                textColor: '#000',
                halign: 'center',
                cellWidth: 'wrap',
              },
              columnStyles: {
                0: {
                  cellWidth: 15,
                },
              },
              startY: data.cell.y + 2,
              margin: {
                left: data.cell.x + data.cell.padding('left'),
              },
              tableWidth: 'wrap',
              theme: 'grid',
              styles: {
                fontSize: 7,
                cellPadding: 1,
              },
              didParseCell: function (data) {
                if (
                  data.row.section === 'body' &&
                  data.column.index !== 0 &&
                  data.column.index !== data.table.columns.length - 2 &&
                  data.column.index !== data.table.columns.length - 1
                ) {
                  if (Number(data.cell.raw) < Number(parametro_enfermeiro)) {
                    data.cell.styles.textColor = [194, 10, 16] // vermelho
                  } else {
                    data.cell.styles.textColor = [2, 99, 57] // verde
                  }
                }
                // verifica a última coluna
                if (
                  data.row.section === 'body' &&
                  data.column.index === data.table.columns.length - 1
                ) {
                  if (Number(data.cell.raw) < 0) {
                    data.cell.styles.textColor = [194, 10, 16] // vermelho
                  } else {
                    data.cell.styles.textColor = [2, 99, 57] // verde
                  }
                }
              },
            })
            // Tabela médico
            let headMedico = atendimentos.map((el) => el.mes_atend)
            let bodyMedico = atendimentos.map((el) => el.medico)
            headMedico.unshift('Função')
            bodyMedico.unshift('Médico')
            headMedico.push('Parâmetro')
            bodyMedico.push(parametro_medico)
            headMedico.push('Diferença')
            bodyMedico.push(
              Number(atendimentos[atendimentos.length - 1].medico) -
                Number(parametro_medico)
            )
            doc.autoTable({
              head: [[...headMedico]],
              body: [[...bodyMedico]],
              headStyles: {
                fillColor: '#ccc',
                fontSize: 6,
                textColor: '#000',
                halign: 'center',
                cellWidth: 'wrap',
              },
              columnStyles: {
                0: {
                  cellWidth: 15,
                },
              },
              startY: data.cell.y + 15,
              margin: {
                left: data.cell.x + data.cell.padding('left'),
              },
              tableWidth: 'wrap',
              theme: 'grid',
              styles: {
                fontSize: 7,
                cellPadding: 1,
              },
              didParseCell: function (data) {
                if (
                  data.row.section === 'body' &&
                  data.column.index !== 0 &&
                  data.column.index !== data.table.columns.length - 2 &&
                  data.column.index !== data.table.columns.length - 1
                ) {
                  if (Number(data.cell.raw) < Number(parametro_medico)) {
                    data.cell.styles.textColor = [194, 10, 16] // vermelho
                  } else {
                    data.cell.styles.textColor = [2, 99, 57] // verde
                  }
                }
                // verifica a última coluna
                if (
                  data.row.section === 'body' &&
                  data.column.index === data.table.columns.length - 1
                ) {
                  if (Number(data.cell.raw) < 0) {
                    data.cell.styles.textColor = [194, 10, 16] // vermelho
                  } else {
                    data.cell.styles.textColor = [2, 99, 57] // verde
                  }
                }
              },
            })
          }
        },
        willDrawCell: function (data) {
          if (data.row.section === 'body') {
            let atendimentos = data.row.raw[3]
            let ultimo_atendimento_enfermeiro =
              atendimentos[atendimentos.length - 1].enfermeiro
            let ultimo_atendimento_medico =
              atendimentos[atendimentos.length - 1].medico
            if (
              Number(
                ultimo_atendimento_enfermeiro - Number(parametro_enfermeiro) < 0
              ) ||
              Number(ultimo_atendimento_medico - Number(parametro_medico) < 0)
            ) {
              doc.setTextColor(194, 10, 16) // vermelho
            } else {
              doc.setTextColor(2, 99, 57) // verde
            }
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

function formatTable(data_pdf) {
  let table = []
  let rows = []
  for (let i = 0; i < data_pdf.length; i++) {
    rows[i] = Object.values(data_pdf[i])
  }
  for (var i = 0; i < rows.length; i++) {
    var tableRow = rows[i]
    for (var i = 0; i < rows.length; i++) {
      var tableRow = rows[i]
      var rowData = []
      if (tableRow.length != 0) {
        for (var j = 0; j < tableRow.length; j++) {
          rowData.push(tableRow[j])
        }
      } else {
        continue
      }
      table.push(rowData)
    }
  }
  return table
}
export const dataFields = {
  'Unidade de saúde': 'no_unidade_de_saude',
  Equipe: 'no_equipe',
  INE: 'nu_ine',
}
